import React from 'react';

// Create simple mock icons which are not mapped in Stencil V4
export const IconExclamationCircle = (props) => <span {...props}>❗</span>;
export const IconExclamationTriangle = (props) => <span {...props}>⚠️</span>;